/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Frame name
 */
export enum Frame {
  NONE = 'none',
  GRAPHITE = 'graphite',
  WHITE = 'white',
  BLACK = 'black',
  NATURAL = 'natural',
}
